import React, { Fragment, useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

import { NavigationHeader } from "../../../Components/Header";
import { SectionTitle } from "../../../Components/Title";
import { SearchInput } from "../../../Components/FormElements";
import { Modal } from "bootstrap";
import AllSipList from "../../../Components/Modal/all-siplist";
import APIService from "../../../Services/api-service";
import { toast } from "react-toastify";
import { SingleSipModal } from "../../../Components/Modal";

const SIPCalendarView = React.memo(() => {
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedDateEvents, setSelectedDateEvents] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedDate, setSelectedDate] = useState("");
    const [loader, setLoader] = useState(true);
    const [currentView, setCurrentView] = useState("dayGridMonth");
    const [calendarList, setCalendarList] = useState([]);
    console.log('calendarList', calendarList);

    const [showSingleModal, setShowSingleModal] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);


    // Track the currently displayed month in YYYY-MM
    const [currentMonth, setCurrentMonth] = useState(() => {
        const now = new Date();
        const y = now.getFullYear();
        const m = String(now.getMonth() + 1).padStart(2, '0');
        return `${y}-${m}`;
    });

    console.log('currentMonth', currentMonth);


    // const [events] = useState([
    //     { title: "Chetan - ₹5k", fund: "ICICI Prudential Smallcap Direct Plan Growth", amount: 5000, name: "Chetan", date: "2025-09-01T10:00:00" },
    //     { title: "Chetan - ₹5k", fund: "ICICI Prudential Smallcap Direct Plan Growth", amount: 5000, name: "Chetan", date: "2025-09-01T13:00:00" },
    //     { title: "Chetan - ₹5k", fund: "ICICI Prudential Smallcap Direct Plan Growth", amount: 5000, name: "Chetan", date: "2025-09-01T11:00:00" },
    //     { title: "Chetan - ₹5k", fund: "ICICI Prudential Smallcap Direct Plan Growth", amount: 5000, name: "Chetan", date: "2025-09-01T15:00:00" },
    //     { title: "Chetan - ₹5k", fund: "ICICI Prudential Smallcap Direct Plan Growth", amount: 5000, name: "Chetan", date: "2025-09-01T18:00:00" },
    //     { title: "Chetan - ₹5k", fund: "ICICI Prudential Smallcap Direct Plan Growth", amount: 5000, name: "Chetan", date: "2025-09-05T19:00:00" },
    //     { title: "Anita - ₹5k", fund: "ICICI Prudential Smallcap Direct Plan Growth", amount: 5000, name: "Anita", date: "2025-09-10T10:00:00" },
    //     { title: "Crise - ₹20k", fund: "ICICI Prudential Smallcap Direct Plan Growth", amount: 5000, name: "Crise", date: "2025-09-20T15:00:00" },
    // ]);

    useEffect(() => {
        if (showModal) {
            const modalElement = new Modal(document.getElementById('all-sip-list'));
            modalElement.show();
        }
    }, [showModal]);

    useEffect(() => {
        if (showSingleModal) {
            const modalElement = new Modal(document.getElementById('single-sip-modal'));
            modalElement.show();
        }
    }, [showSingleModal]);

    useEffect(() => {
        _sipCalendarView();
    }, [currentMonth, searchQuery]);

    function _handleSearchQuery(value) {
        setSearchQuery(value);
    };

    const _sipCalendarView = () => {
        setLoader(true);
        const url = "sip/calendar-list";
        const data = {
            "data": currentMonth,
            "query": searchQuery || ""
        }
        APIService(true, url, data).then((response) => {
            if (response.status_code === 200) {
                // Normalize events so week/day show them as all-day (no time-wise view)
                const normalized = (response.data || []).map((evt) => {
                    if (!evt) return evt;
                    const dateKey = evt.start || evt.date || evt.event_date || evt.day || evt.dt;
                    if (dateKey) {
                        return { ...evt, start: dateKey, allDay: true };
                    }
                    return evt;
                });
                setCalendarList(normalized);
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                });
            }
            setLoader(false);
        })
    };


    return (
        <Fragment>
            <NavigationHeader type={1}
                title="Calendar View" />
            <div className="ps-4 pe-lg-5 pe-md-2 pe-2 padding-32px-top">
                <div className="row align-items-center">
                    <div className="col-3">
                        <SectionTitle title="SIP list" />
                    </div>
                    <div className="col-lg-9 d-flex justify-content-end pe-0">
                        <SearchInput placeholder="Search with name"
                            value={searchQuery}
                            valueChange={_handleSearchQuery}
                            handleSearch={() => { }}
                            divClass="w-50 ms-2 h-100" />

                    </div>
                    <div className="col-12 pt-4">
                        <FullCalendar
                            plugins={[dayGridPlugin, interactionPlugin]}
                            initialView="dayGridMonth"
                            headerToolbar={{
                                left: "prev title next",
                                right: "dayGridMonth,dayGridWeek,dayGridDay",
                            }}
                            datesSet={(info) => {

                                setCurrentView(info.view.type);
                                // Derive month from the view's start date to keep API in sync
                                const calendarDate = info.view.calendar.getDate();
                                const y = calendarDate.getFullYear();
                                const m = String(calendarDate.getMonth() + 1).padStart(2, '0');
                                const newMonth = `${y}-${m}`;
                                if (newMonth !== currentMonth) {
                                    setCurrentMonth(newMonth);
                                }
                            }}
                            // dayHeaderFormat={{
                            //     weekday: "long", // "Thursday"
                            //     day: "numeric",  // "18"
                            //     month: "short",  // "Sept"
                            // }}
                            moreLinkClick={(info) => {
                                info.jsEvent.preventDefault();
                                info.jsEvent.stopPropagation();
                                setSelectedDate(
                                    new Date(info.date).toLocaleDateString("en-US", {
                                        year: "numeric",
                                        month: "long",
                                        day: "numeric",
                                    })
                                );
                                setSelectedDateEvents(info.allSegs.map((seg) => seg.event));
                                setShowModal(true);
                                // setShowModal(true);
                                return false; // prevents navigation to day view
                            }}
                            events={calendarList}
                            // dayMaxEventRows={currentView === "dayGridDay" ? 30 : 3}
                            dayMaxEvents={currentView === "dayGridMonth" ? 2 : false}


                            eventClick={(info) => {
                                info.jsEvent.preventDefault();
                                info.jsEvent.stopPropagation();

                                const clickedDate = info.event.startStr.split("T")[0];

                                const filteredEvents = calendarList.filter(evt => {
                                    const evtDate = evt.start?.split("T")[0];
                                    return evtDate === clickedDate;
                                });

                                setSelectedDateEvents(filteredEvents); // ✅ only that day’s SIPs
                                setSelectedDate(
                                    new Date(info.event.start).toLocaleDateString("en-US", {
                                        year: "numeric",
                                        month: "long",
                                        day: "numeric",
                                    })
                                );

                                setShowSingleModal(true);
                            }}


                        />
                    </div>
                    {
                        showModal &&
                        <AllSipList date={selectedDate}
                            events={selectedDateEvents}
                            close={() => setShowModal(false)} />
                    }

                    {showSingleModal && (
                        <SingleSipModal
                            date={selectedDate}
                            events={selectedDateEvents}  //  only that day's SIPs
                            close={() => setShowSingleModal(false)}
                        />
                    )}


                </div>
            </div>
        </Fragment>
    )
})

export default SIPCalendarView;